import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { rulesService, type NewRuleInput } from '../services/rules.service';

const KEY = 'classification-rules';

export function useRules(companyId: string) {
  return useQuery({
    queryKey: [KEY, companyId],
    queryFn: () => rulesService.list(companyId),
    enabled: companyId !== '',
  });
}

export function useCreateRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: NewRuleInput) => rulesService.create(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
  });
}

export function useSetRuleStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: { id: string; status: 'ACTIVE' | 'DISABLED'; reason?: string | null }) =>
      rulesService.setStatus(v.id, v.status, v.reason),
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
  });
}
